import { useTranslation } from 'react-i18next';
import AndroidLinkImage from '../assets/images/google-play.png';
import IosLinkImage from '../assets/images/appstore.svg';

const MobileModal = () => {
  const { t } = useTranslation();

  // Обе ссылки есть в разметке (и в пререндере), видна одна — по классу is-android / is-ios на <html>:
  // раньше ссылка появлялась только после загрузки JS и сдвигала окно (CLS)
  const renderContent = () => (<>
    <a
      className='mobile__google-play-link'
      href='https://play.google.com/store/apps/details?id=mendeleev.redlime'
    >
      <img
        loading='lazy'
        src={AndroidLinkImage}
        width={160}
        height={62}
        alt='Google Play'
      />
    </a>
    <a
      className='mobile__app-store-link'
      href='https://apps.apple.com/app/id1451726577'
    >
      <img
        loading='lazy'
        src={IosLinkImage}
        width={120}
        height={40}
        alt='Apple Appstore'
      />
    </a>
  </>);

  return (<section className='mobile'>
      <div className='mobile__wrapper'>
        <div className='mobile__pt-label'>
          <img
            loading='lazy'
            className='mobile__app-logo'
            src={require('../assets/images/mobile-icon.svg').default}
            width={70}
            height={70}
            alt=''
          />
          <span className='mobile__app-name'>
            <span>{t('periodic_table_1')}</span>
            <br />
            <span>{t('periodic_table_2')}</span>
          </span>
        </div>
      </div>
      <div className='mobile__phone'>
        <div className='mobile__phone-wrapper'>
          {/* lazy: на компьютерах окно скрыто (display: none) — такие картинки браузер не загружает.
              loading — до src: React выставляет атрибуты по порядку, иначе загрузка начнётся сразу */}
          <picture>
            <source type='image/webp' srcSet={require('../assets/images/smartphone@2x.webp')} />
            {/* fetchpriority: на телефоне это самая крупная картинка первого экрана (LCP) */}
            <img loading='lazy'
                 fetchpriority='high'
                 src={require('../assets/images/smartphone@1x.png')}
                 srcSet={require('../assets/images/smartphone@2x.png')}
                 alt='' />
          </picture>
          <div className='mobile__decoration'/>
        </div>
      </div>
      <div className='mobile__apps'>
        <div className='mobile__apps-wrapper'>
          <h2
            className='mobile__title'>{`${t('periodic_table_1')} ${t('periodic_table_2')}`} – <span>Mobile</span></h2>
          <div>
            <p className='mobile__description'>
              {t('string.translate.mobile_modal1')}{' '}
              <a href='https://periodic-table.tech/' className='mobile__link'>
                periodic-table.tech
              </a>{' '}
              {t('string.translate.mobile_modal2')}
              <br/>
              {t('string.translate.mobile_modal3')}
            </p>
          </div>
          <div className='mobile__store-links'>{renderContent()}</div>
        </div>
      </div>
    </section>);
};

export default MobileModal;
